import { getAwsAssets } from "@src/utils/index";
import { Image } from "@src/components/Image";
import React from "react";

import styles from "@src/components/Tabs/Announcements/styles/Announcements.module.scss";
import { t } from "i18next";

const NoCouponScreen = () => {
  return (
    <div className={styles.noContentScreen}>
      <Image
        src={getAwsAssets("noCouponsThumbnail.svg", "Overview")}
        alt="No coupon available"
        height={140}
        width={140}
      />
      <h4 style={{ marginTop: "24px" }}>
        {t(
          "components.bottomSheets.components.noCouponScreen.noCouponHeading",
          "No coupons available"
        )}
      </h4>
      <p style={{ marginTop: "8px", marginBottom: "60px" }}>
        {t(
          "components.bottomSheets.components.noCouponScreen.noCouponText",
          "Do you have any alternate coupon code with you? Try entering that and see if you get lucky"
        )}{" "}
        {`:)`}
      </p>
    </div>
  );
};

export default NoCouponScreen;
